<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-overlay :show="unitLoad">
              <b-row>
                <b-col lg="6" sm="12">
                  <label class="mr-4">{{ $t('retailerManagement.delivery_order_id') + ': ' }}</label>
                  <span class="capitalize" v-if="dataArray.sc_delivery_main.product_type === 1">{{ 'P - ' }}{{ dataArray.sc_delivery_main.delivery_id }}</span>
                  <span class="capitalize" v-else>{{ 'W - ' }}{{ dataArray.sc_delivery_main.delivery_id }}</span>
                </b-col>
                <b-col lg="6" sm="12">
                  <label class="mr-4">{{ $t('externalUser.production.return_date') + ': ' }}</label>
                  <span class="text-dark">{{ dataArray.return_date | dateFormat }}</span>
                </b-col>
                <b-col lg="12" sm="12" class="form-for-textarea">
                  <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                    <b-form  @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset">
                          <b-table-simple striped bordered small>
                              <b-tr style="background-color: #66CC99; color: white">
                                  <b-th class="text-center">{{ $t('globalTrans.sl_no') }}</b-th>
                                  <b-th>{{ $t('production_store.pro_category') }}</b-th>
                                  <b-th>{{ $t('retailerManagement.product_name') }}</b-th>
                                  <b-th>{{ $t('retailerManagement.unit') }}</b-th>
                                  <b-th>{{ $t('retailerManagement.delivery_quantity') }}</b-th>
                                  <b-th>{{ $t('retailerManagement.received_quantity') }}</b-th>
                                  <b-th>{{ $t('globalTrans.return') + ' ' + $t('retailerManagement.quantity') }}</b-th>
                                  <b-th>{{ $t('retailerManagement.wasted_product') }}</b-th>
                                  <b-th>{{ $t('retailerManagement.good_product') }}</b-th>
                                  <b-th>{{ $t('retailerManagement.unit_price') }}</b-th>
                                  <b-th>{{ $t('retailerManagement.total_price') }}</b-th>
                              </b-tr>
                              <b-tr v-for="(item, index) in dataArray.details" :key="index">
                                  <b-td class="text-center">{{ $n(index + 1) }}</b-td>
                                  <b-td>{{ getCategoryName(item.product_id) }}</b-td>
                                  <b-td>{{ productNameById(item.product_id) }}</b-td>
                                  <b-td>{{ unitNameById(item.unit_id) }}</b-td>
                                  <b-td>{{ $n(item.quantity) }}</b-td>
                                  <b-td>{{ item.received_quantity }}</b-td>
                                  <b-td>{{ item.return_quantity }}</b-td>
                                  <b-td>
                                      <ValidationProvider name="Wasted Product Qty" :rules="'max_value:'+item.return_quantity+'|numeric|required'">
                                          <b-form-group
                                            class="mb-0"
                                            slot-scope="{ valid, errors }"
                                          >
                                              <b-form-input
                                                type="number"
                                                v-model="item.wasted_product_qty"
                                                @input="changeWastedQty(item)"
                                                :state="errors[0] ? false : (valid ? true : null)"
                                              ></b-form-input>
                                              <div class="invalid-feedback">
                                                {{ errors[0] }}
                                              </div>
                                          </b-form-group>
                                      </ValidationProvider>
                                  </b-td>
                                  <b-td>{{ $n(item.good_product_qty) }}</b-td>
                                  <b-td>{{ $n(item.unit_price) }}</b-td>
                                  <b-td>{{ $n(item.total_price) }}</b-td>
                              </b-tr>
                              <b-td colspan="10">
                                  <p style="margin-left:85%">{{ $t('sales_distribution_admin.grand_price') }}</p>
                              </b-td>
                              <b-td>{{ $n(sumTotal) }}</b-td>
                              <b-tr v-if="dataArray.details.length > 0">
                                <b-td colspan="10">
                                    <b-col lg="12" sm="12">
                                      <b-row>
                                        <b-col lg="4" sm="12">
                                          <label class="mr-4">{{ $t('retailerManagement.delivery_date') + ': ' }}</label>
                                          <span class="text-dark">{{ dataArray.sc_delivery_main.delivery_date | dateFormat }}</span>
                                        </b-col>
                                        <b-col lg="4" sm="12">
                                          <label class="mr-4">{{ $t('retailerManagement.contact_no') + ': ' }}</label>
                                          <span class="capitalize">{{ dataArray.sc_delivery_main.contact_no | mobileNumber }}</span>
                                        </b-col>
                                        <b-col lg="4" sm="12">
                                          <label class="mr-4">{{ $t('retailerManagement.delivery_location') + ': ' }}</label>
                                          <span class="capitalize">{{ dataArray.sc_delivery_main.delivery_location }}</span>
                                        </b-col>
                                      </b-row>
                                    </b-col>
                                </b-td>
                              </b-tr>
                          </b-table-simple>
                          <b-row>
                            <b-col lg="12" sm="12">
                                <p class="text-muted font-weight-bold">
                                    <span v-if="$i18n.locale === 'en'">
                                      [Note: Central stock will decremented according to wasted product quantity and incremented according to good product quantity.]
                                    </span>
                                    <span v-else>[বি.দ্র: নষ্ট পণ্যের পরিমাণ অনুযায়ী কেন্দ্রীয় স্টক হ্রাস পাবে এবং ভাল পণ্যের পরিমাণ অনুযায়ী বৃদ্ধি পাবে।]</span>
                                </p>
                            </b-col>
                            <b-col lg="6" sm="12">
                                <ValidationProvider name="Comment (En)" vid='comments' rules="required">
                                    <b-form-group
                                    class="row"
                                    label-cols-sm="12"
                                    label-for="comments"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                      {{ $t('production_store.comment_en')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-textarea
                                    id="note"
                                    v-model="dataArray.comments"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    ></b-textarea>
                                    <div class="invalid-feedback">
                                      {{ errors[0] }}
                                    </div>
                                  </b-form-group>
                                </ValidationProvider>
                              </b-col>
                              <b-col lg="6" sm="12">
                                <ValidationProvider name="Comment (Bn)" vid='comments_bn' rules="required">
                                  <b-form-group
                                  class="row"
                                  label-cols-sm="12"
                                        label-for="comments_bn"
                                        slot-scope="{ valid, errors }"
                                        >
                                        <template v-slot:label>
                                          {{ $t('production_store.comment_bn')}} <span class="text-danger">*</span>
                                        </template>
                                        <b-textarea
                                        id="comments_bn"
                                        v-model="dataArray.comments_bn"
                                        :state="errors[0] ? false : (valid ? true : null)"
                                        ></b-textarea>
                                        <div class="invalid-feedback">
                                          {{ errors[0] }}
                                        </div>
                                    </b-form-group>
                                  </ValidationProvider>
                                </b-col>
                              </b-row>
                              <div class="row">
                                <div class="col-sm-3"></div>
                                <div class="col text-right">
                                  <b-button type="submit" variant="primary" class="mr-1">{{ $t('retailerManagement.adjust') }}</b-button>
                                  &nbsp;
                                  <b-button variant="danger" @click="$bvModal.hide('modal-adjust')">{{ $t('globalTrans.cancel') }}</b-button>
                                </div>
                            </div>
                      </b-form>
                  </ValidationObserver>
                </b-col>
              </b-row>
            </b-overlay>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { productionServiceBaseUrl } from '@/config/api_config'
import { adjustDeliveryOrderUpdateApi } from '../../api/routes'
import { core } from '@/config/pluginInit'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      dataArray: {},
      sumTotal: 0,
      unitLoad: false
    }
  },
  computed: {
    currentLocale: function () {
        return this.$i18n.locale
    }
  },
  created () {
    if (this.id) {
      const tmp = this.getStateData()
      this.dataArray = tmp
      this.dataArray.comments = ''
      this.dataArray.comments_bn = ''
      this.getGrandTotal()
    }
  },
  mounted () {
    core.index()
  },
  methods: {
    getGrandTotal () {
      let sumM = 0
      this.dataArray.details.forEach(function (data) {
        sumM = sumM + parseFloat(data.total_price)
      })
      this.sumTotal = parseFloat(sumM) ? sumM : 0
    },
    changeWastedQty (item) {
      item.good_product_qty = item.return_quantity - item.wasted_product_qty
    },
    getStateData () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      const tmp = JSON.parse(JSON.stringify(tmpData))
      const newData = tmp.details.map(item => {
        const deliveryDetails = tmp.sc_delivery_main.delivery_details.find(el => el.product_id === item.product_id && el.unit_id === item.unit_id)

        return Object.assign(item, {}, {
          return_quantity: item.quantity,
          quantity: deliveryDetails.quantity,
          received_quantity: deliveryDetails.receive_quantity,
          wasted_product_qty: 0,
          good_product_qty: item.quantity
        })
      })
      return Object.assign({}, tmp, { details: newData })
    },
    getCategoryName (Id) {
      const product = this.$store.state.ProductionService.commonObj.productList.find(product => product.value === Id)
      if (typeof product !== 'undefined') {
        const Obj = this.$store.state.ProductionService.commonObj.productCategoryList.find(el => el.value === product.category_id)
        return typeof Obj !== 'undefined' ? (this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn) : ''
      }
      return ''
    },
    productNameById (id) {
        const product = this.$store.state.ProductionService.commonObj.productList.find(product => product.value === id)
        if (this.$i18n.locale === 'bn') {
            return product.text_bn
        } else {
            return product.text_en
        }
    },
    unitNameById (id) {
      const unit = this.$store.state.ProductionService.commonObj.productUnitList.find(unit => unit.value === id)
      if (this.$i18n.locale === 'bn') {
          return unit.text_bn
      } else {
          return unit.text_en
      }
    },
    async saveData () {
          this.$store.dispatch('mutateCommonProperties', { loading: true })
          let result = null
          const loadingState = { loading: false, listReload: false }
          this.unitLoad = true
          if (this.id) {
              result = await RestApi.postData(productionServiceBaseUrl, adjustDeliveryOrderUpdateApi, this.dataArray)
          }

          loadingState.listReload = true
          this.$store.dispatch('mutateCommonProperties', loadingState)
          this.unitLoad = false
          if (result.success) {
              if (result.notification && this.$store.state.emitNotification) {
                  const notification = result.notification
                  this.$socket.emit('send-notification', notification)
              }
              this.$toast.success({
                  title: this.$t('globalTrans.success'),
                  message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
                  color: '#D6E09B'
              })
              this.$bvModal.hide('modal-adjust')
          } else {
              this.$toast.error({
                  title: this.$t('globalTrans.error'),
                  message: result.message,
                  color: '#D6E09B'
              })
              this.$refs.form.setErrors(result.errors)
          }
    }
  }
}
</script>
